'use strict';

import { CoreRepository } from '../CoreRepository';
import { IndProvider } from '../../Entities/Ind/IndProvider';
import { IndProviderCollection } from '../../Collections/Ind/IndProviderCollection';

export class IndProviderRepository extends CoreRepository {
  /*public getIndProvider(individualId: number, options: object = {}) {
      if (!options) {
        options = {};
      }
  
      return this.webAPI.getInd(individualId, options)
        .then(response => {
          let user = new Ind();
          user.hydrate(response);
  
          return user;
        });
  
    }
  
    public getInds(options: object = {}, criteria: object = null) {
      if (!options) {
        options = {};
      }
  
      if (criteria) {
        options['criteria'] = criteria;
      }
  
      return this.webAPI.getInds(options)
        .then(response => {
          let collection = new IndCollection();
  
          response.data.forEach(collectionItemData => {
            let collectionItem = new Ind();
            collectionItem.hydrate(collectionItemData);
  
            collection.addItem(collectionItem);
          });
  
          collection.setOffset(response.offset);
          collection.setLimit(response.limit);
          collection.setTotal(response.total);
  
          return collection;
        });
  
    }
  
    
  */

  public createIndProvider(indId: number, payload: any[]) {
    return this.webAPI.createIndProvider(indId, payload).then((response) => {
      const indProvider = new IndProvider();
      indProvider.hydrate(response);

      return indProvider;
    });
  }

  public removeIndProvider(indId: number, indProviderId: number) {
    return this.webAPI.removeIndProvider(indId, indProviderId).then((response) => {
      return response;
    });
  }

  public updateIndProvider(indId: number, indProviderId: number, payload: any[]) {
    return this.webAPI.updateIndProvider(indId, indProviderId, payload).then((response) => {
      return response;
    });
  }

  public moveIndProvider(individualId: number, individualProviderId: number, payload: any[]) {
    return this.webAPI
      .moveIndProvider(individualId, individualProviderId, payload)
      .then((response) => {
        return response;
      });
  }
}
